<template>
  <div class="accordionWrapper">

    <div class="accordionScroller" ref="scroller1">
      <div :class="['accordion']"><!-- @mouseleave="activeIndex = -1" , 'mx-2xl' -->
        <!--
        <div style="color:black;">
          activeIndex = {{activeIndex}}<br/><br/>
        </div>-->      
        <hp-accordionitem
          v-for="(item, index) in children"
          :key="index"
          :item="item"
          :index="index"
          :isactive="activeIndex === index"
          :scrolledIndex = "currentPage"
          @mouseenter.native="activeIndex = index" >
        </hp-accordionitem>
        <!-- :is-active="dimensions.width < 1101 || $device.ipad || activeIndex === index" -->    
      </div>
    </div>

    <!--
    <div class="accPager">
        <sidepager
            @item-change = "onPagerChange"
            :skinMode="0"
            :itemIndex="currentPage" 
            :itemsPerPage="1"
            :mobilePagesCount = "children.length"
            :items="children">
        </sidepager>
    </div>
    -->

  </div>
</template>

<script>
//http://localhost:8080/demo3

import { mapState } from "vuex";
import hpAccordionitem from "./hpAccordionItem.vue";
import sidepager from "@/views/com/sidepager.vue";

export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    size: String
  },
  components: { hpAccordionitem,sidepager },
  data() {
    return {
      currentPage:0,
      activeIndex: 0,
      scrollTimer:-1,
      isScrolling:false,
      scrollingEnded:true,//when user ended scrolling

    };
  },
  mounted() {
    //console.log("$device > ", this.$device);
    this.initScrollListener();
  },
  destroyed() {
      this.removeScrollListener();
  },

  computed: {
    ...mapState(["dimensions"]),
    parsedChildren() {
      return _.filter(this.children, "url");
    }
  },
  methods: {
    onPagerChange(index)
    {
      this.navTo(index);
    },
    navTo(index)
    {
      this.activeIndex = index;
      let scrollToElement = this.$refs.scroller1.getElementsByClassName("accordion--item")[index];
      scrollToElement.scrollIntoView(
      { 
          behavior: 'smooth',
          inline:'center',
          block:'nearest' }
      );      
    },
    initScrollListener() {
        var vm = this;
        let scroller = this.$refs.scroller1;
        scroller.addEventListener("scroll", vm.onThumbsScroll, false);
    },
    removeScrollListener() 
    {
        var vm = this;
        let scroller = this.$refs.scroller1;
        if(scroller!=null){
            scroller.removeEventListener("scroll", vm.onThumbsScroll);
        }
    },
    onThumbsScroll() {
        var vm = this;
        if (vm.scrollTimer != -1){clearTimeout(vm.scrollTimer);}                
        vm.scrollTimer = setTimeout(() => {
            vm.onThumbsScrollFinished();
        }, 50);            //500
    },
    onThumbsScrollFinished()
    {
        //Check the scroll position after the scroll has ended
        this.checkScrollPosition();
    },
    checkScrollPosition() {
        var vm=this;
        let scroller = this.$refs.scroller1;
        let scrolledX = scroller.scrollLeft;
        var reveals = scroller.querySelectorAll(".accordion--item");        
        for (var i = 0; i < reveals.length; i++) {

            let diff = Math.abs(scrolledX-reveals[i].offsetLeft);
            console.log("element:"+i+" diff:"+diff);
            if(diff<140){
                //.scrolledToIndex = i;
                //let itemsPerPage = 1;//on desktop
                //if(this.isMobile){
                    //itemsPerPage=1;//on mobile
                //}            
                //let pageIndex = i;//Math.floor(i);///itemsPerPage);
                //this.$emit('page-scrolled',pageIndex);
                //update the pager buttons
                vm.currentPage = i;//this will update the buttons
                vm.activeIndex = i;//this will update the thumbs
            }
        }
    },         
    activateItem: _.debounce(function(index) {
      this.activeIndex = index;
    }, 300)    
  }
};
</script>

<style scoped>
</style>

<style lang="stylus" scoped>
.accordionWrapper
  width 100%
  height auto
.btn-group
  _flex(column,wrap, stretch, flex-start)
  max-width 240px
  position relative
  z-index 2
.accordion
  margin-top 55px
  margin-bottom 25px
  +below(600px, orientation: portrait)
    marg('2xl', top)
  +desktop()
    height 50vh
    _flex(row,wrap,stretch,space-evenly)
  +above(1800px)
    height 28vw
  +below(1100px)
    _flex(row,wrap,flex-start,space-between)
    /* Portrait and Landscape ////////////////////////// */
    //@media (min-device-width: 1024px), (max-device-height: 1366px), (-webkit-min-device-pixel-ratio: 1.5), (orientation: portrait)
    //_flex(row,wrap,stretch,space-evenly)
    //border solid 5px red
    //_flex(row,wrap,flex-start,space-between)
    //height auto
    //column-gap 20px
    
</style>

<style>
    .accPager
    {
      display: none;
    }
    .accordionScroller
    {
      width: 100%;
      height: auto;
    }

    /* Portrait ipad pro */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) {
        .accordion
        {
            column-gap:20px;
        }
    }


    @media screen and (max-width: 835px) {
        .accordionWrapper
        {
          width: 100%;
          height: auto;
        }
        .accordionScroller
        {
            overflow-x:scroll;
            scroll-snap-type: x mandatory;
            -webkit-overflow-scrolling: touch;
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
        }        
        .accordion
        {
            flex-wrap: nowrap;
            justify-content: initial;
            width: 420vw;     
            margin-right: 5vw;     
        }
        .accPager
        {
            padding-top: 0px;
            width: 30vw;
            text-align: center;
            margin: auto;
            display: block;
        }
    }  

</style>
